module.exports = __webpack_public_path__ + "assets/img/floaters.b40bece2.png";